<template>
  <tbody v-if="inventory" class="tbody">
    <tr style="height: 50px">
      <td>{{ inventory.articleName }}</td>

      <td class="text-center">
        {{ inventory.purchase ? inventory.purchase.billNo : "" }}
      </td>

      <td class="text-center">{{ formatDate(inventory.purchaseDate) }}</td>

      <td class="text-center">{{ formatDate(inventory.expiryDate) }}</td>

      <td class="text-center">{{ inventory.units }}</td>

      <td class="text-center">{{ inventory.available }}</td>

      <td class="text-center">
        {{ inventory.consumptions ? inventory.consumptions.length : "" }}
      </td>

      <td>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          :to="'/inventory/' + inventory._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  name: "InventoryRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
    _filterFor: {
      default: null,
    },
  },
})
export default class InventoryRow extends Vue {
  inventory = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.inventory = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.inventory = val;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>